import { useState, useEffect } from "react";

const KEY = "sf_wishlist";
const EVT = "sf-wishlist";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch { return []; }
};
const write = (arr) => {
  localStorage.setItem(KEY, JSON.stringify(arr));
  window.dispatchEvent(new Event(EVT));
};

export const getWishlist = () => read();
export const isWishlisted = (id) => read().includes(id);
export const toggleWishlist = (id) => {
  const a = read();
  const i = a.indexOf(id);
  if (i >= 0) a.splice(i, 1); else a.unshift(id);
  write(a);
  return a.includes(id);
};

const useWishlistStore = () => {
  const [ids, setIds] = useState(read);
  useEffect(() => {
    const on = () => setIds(read());
    window.addEventListener(EVT, on);
    window.addEventListener("storage", on);
    return () => { window.removeEventListener(EVT, on); window.removeEventListener("storage", on); };
  }, []);
  return ids;
};

export const useWishlist = () => useWishlistStore();
export const useWishlistCount = () => useWishlistStore().length;
